import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, {
  useEffect,
  useState,
  useRef,
  useMemo
} from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import _ from 'lodash';
import useResponsive from '../../../../../../utils/responsive';
import { Button } from '../../../../../common';
import { SummaryItem } from '../../../DeliverySummary';
import Layout from '../../../Layout';
import TimeSlot from './TimeSlot';
import { useLanguage } from '../../../../../../context/language/language';
import useDeliveryControlFlow from '../../../../../common/hook/useDeliveryControlFlow';
import useDeliveryData from '../../../../../common/hook/useDeliveryData';
import { SELECT_STORE, DELIVERY_ADDRESS, SUMMARY_DELIVERY } from '../../../../../../constant/deliveryFlow';
import useDeliverySlot from '../../../../../common/hook/useDeliverySlot';
import { useSite } from '../../../../../../context/siteContext';
import { defaultModalSize, mobileContentContainerHeight } from '../../../modalSize';
import { trackPageLoad } from '../../../../../../utils/adobeAnalytics';
import { trackClickConfirmSelectDelivery } from '../../../../../../utils/eventTracking';
import { determineStoreType } from '../../../../../../store/bootstrap/api';
import { selectCurrentWebSiteCode } from '../../../../../../store/stores/selector';
import isMatchUrl from '../../../../../../constant/urlPattern';

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: 12,
  },
  title: {
    ...theme.fonts.header5,
    color: theme.custom.colors.primaryText,
  },
  titleUser: {
    ...theme.fonts.textS,
    fontWeight: 500,
    marginTop: '8px',
    color: theme.custom.colors.primaryText,
  },
  pos: {
    marginTop: '4px',
  },
  subheader: {
    ...theme.fonts.textM,
    color: theme.custom.colors.gray500,
  },
  action: {
    ...theme.fonts.textM,
    color: theme.custom.colors.green600,
    textDecoration: 'none',
    display: 'flex',
    marginTop: '15px',
    marginRight: '10px',
  },
  Timetitle: {
    ...theme.fonts.header5,
  },
  Descriptionaction: {
    ...theme.fonts.textM,
    color: theme.custom.colors.green600,
    fontWeight: 500,
    textDecoration: 'none',
  },
  Description: {
    // ...theme.fonts.textS,
    display: 'flex',
    flexDirection: 'column',
    ...theme.fonts.textS,
    color: theme.custom.colors.gray500,
  },
  DescriptionChange: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    // color: theme.custom.colors.green500
  },
  BoxTime: {
    ...theme.custom.radius.m,
    display: 'flex',
    height: theme.isMobile ? '220px' : '364px',
    width: '100%',
    overflow: 'hidden',
    boxSizing: 'border-box',
    padding: 16,
    border: `1px solid ${theme.custom.colors.grey100}`,

    ...theme.isMobile && {
      padding: '0 12px',
    }
  },
  Button: {
    width: '100%',
    position: 'absolute',
    bottom: 0,
    background: 'white',
    padding: '12px 0 24px',
    margin: '0 -24px',
    display: 'flex',
    justifyContent: 'center',
    zIndex: 1,
    borderTop: `0.5px solid ${theme.custom.colors.grey100}`,
    [theme.breakpoints.down('md')]: {
      margin: 0,
    },
    [theme.breakpoints.down('sm')]: {
      width: 'calc(100% - 48px)',
      margin: 'auto',
      left: 0,
      right: 0,
      padding: '12px 24px 12px',
    },
  },
  customButton: {
    ...theme.fonts.textL,
    width: 160,
    fontWeight: 700
  },
  selectTimeTitleContainer: {
    display: 'none',

    [theme.breakpoints.up('md')]: {
      margin: '10px 20px',
      display: 'block',
    },

    [theme.breakpoints.up('lg')]: {
      margin: '3px 0 0',
    },
  },
}));

const BoxUser = styled.div(({ theme }) => ({
  ...theme.radius.m,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  border: `1px solid ${theme.colors.grey100}`,
  padding: '12px 16px',

  ...theme.isMobile && {
    padding: '16px 12px',
  }
}));

const BoxTitle = styled.div(({ theme }) => ({
  ...theme.fonts.header4,
  fontWeight: 700,
  color: theme.colors.grey700,

  ...theme.isMobile && {
    ...theme.fonts.textM,
    fontWeight: 700,
  }
}));

const UserAddress = styled.div(({ theme }) => ({
  ...theme.fonts.textM,
  color: theme.colors.grey550,
}));

function CardHeaderUser({ onNext }) {
  const classes = useStyles();
  const word = useLanguage();
  const deliveryData = useDeliveryData();
  const shippingAddress = deliveryData.shippingAddress;
  const { ThSite } = useSite();

  if (shippingAddress.addressNumber && (deliveryData.deliveryMethod.includes('HD') || _.toUpper(deliveryData?.deliveryMethod) === 'B2B')) {
    const {
      addressNumber, thSubDistrict, thDistrict, thProvince, postalCode,
    } = shippingAddress;
    const addressText = ThSite
      ? `${addressNumber} ${thSubDistrict} ${thDistrict} ${thProvince} ${postalCode}`
      : deliveryData.addressText;
    return (
      <BoxUser>
        <Box>
          <BoxTitle>{word('Slot.HomeDelivery.Address')}</BoxTitle>
          <UserAddress>{addressText}</UserAddress>
        </Box>
        <a
          id="slot-booking"
          data-cta-name-en="Slot Booking"
          data-cta-name-th="เปลี่ยน"
          data-cta-type="Link"
          href="#"
          className={classes.Descriptionaction}
          onClick={onNext}
        >
          {word('Slot.Button.Edit')}
        </a>
      </BoxUser>
    );
  }

  return <div />;
}

function CardHeaderDetail({ onBack, showEdit = true }) {
  const { isMobile } = useResponsive();
  const deliveryData = useDeliveryData();
  const store = deliveryData.currentStore;
  const word = useLanguage();

  if (store && store.storeId) {
    let name;
    if (store) {
      name = store.name;
    }

    return (
      <SummaryItem
        id="change-store-button"
        header={name}
        desc={deliveryData.storeAddressText}
        changeHandler={onBack}
        word={word('Slot.Button.Edit')}
        showChange={showEdit}
        style={{ padding: isMobile ? '16px 12px' : '25px 16px' }}
      />
    );
  }
  return '';
}

export default function SlotBooking({
  onNext,
  onBack,
  onClose,
  modalRef
}) {
  const { isMobile, isTablet } = useResponsive();
  const deliveryControl = useDeliveryControlFlow();
  const { ThSite } = useSite();
  const deliveryData = useDeliveryData();
  const deliverySlot = useDeliverySlot();
  const { slotId: currentSlotId, date, fromTime } = deliveryData.currentStore.slot || {};
  const [slotId, setSlotId] = useState(currentSlotId);
  const classes = useStyles();
  const word = useLanguage();
  const currentWebSiteCode = useSelector(selectCurrentWebSiteCode);
  const currentStoreType = determineStoreType(currentWebSiteCode);
  /**
   * TODO
   * --
   * This is solution for default checked timeslot
   * Because data is mock and we not have selected slotId from BE.
   * currentSlotId: is date format in first time.
   */
  useEffect(() => {
    if (!_.isEmpty(deliverySlot.collectionSlot?.dates) && date === slotId) {
      const getSlotByFromTime = (slots) => slots.find((slot) => slot.fromTime === fromTime);
      // eslint-disable-next-line no-use-before-define
      const collectionByDate = deliverySlot.collectionSlot.dates.find((collection) => collection.date === slotId);

      if (!collectionByDate) {
        setSlotId('');
        return;
      }

      const slotByFromTime = getSlotByFromTime(collectionByDate.slots || []);
      const slotIdByFromTime = _.get(slotByFromTime, 'slotId', '');

      if (slotIdByFromTime) {
        setSlotId(slotIdByFromTime);
      } else {
        setSlotId('');
      }
    }
  }, [deliverySlot.collectionSlot]);

  useEffect(() => {
    trackPageLoad(deliveryData.deliveryMethod.startsWith('CC') ? 'Collect Store Slot' : 'Delivery Slot');
  }, []);

  const handleOptionChange = (shopId) => {
    setSlotId(shopId);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    let selectedSlot;
    let dateWithSlot = deliverySlot.collectionSlot?.dates.find((collection) => {
      selectedSlot = collection.slots.find((slot) => slot.slotId === slotId);
      return selectedSlot !== undefined;
    });
    if (slotId) {
      let slotData = {
        date: dateWithSlot.date,
        ...selectedSlot,
      };
      onNext({
        nextPage: SUMMARY_DELIVERY,
        slotData,
      });
      trackClickConfirmSelectDelivery({
        selected_delivery_type: deliveryData.activeDeliveryType,
        selected_delivery_method: deliveryData.activeDeliveryMethod,
        selected_store_id: deliveryData.activeStore.storeId,
        selected_store_name: deliveryData.activeStore.name,
        selected_store_type: currentStoreType === 'hyper' ? 'HY' : 'GF',
        selected_time: `${slotData.fromTime} - ${slotData.toTime}`,
      });
    }
  };

  useMemo(() => {
    if (deliveryData.currentStore.storeId) {
      deliverySlot.getSlot(deliveryData.currentStore.storeId, deliveryData.deliveryMethod, deliveryData.deliveryType);
    }
  }, []);

  const contentContainerRef = useRef(null);
  useEffect(() => {
    const offset = defaultModalSize.mobile.offset;
    if (contentContainerRef?.current?.style) {
      mobileContentContainerHeight(contentContainerRef, isMobile, modalRef, offset);
    }
  }, [contentContainerRef]);

  const getTitle = () => {
    if (deliveryData.deliveryMethod?.startsWith('HD') || _.toUpper(deliveryData?.deliveryMethod) === 'B2B') {
      return word('DeliveryAddress.Type.Options.HomeDelivery');
    }
    if (deliveryData.deliveryMethod?.startsWith('CC')) {
      return word('DeliveryAddress.Type.Options.Collect');
    }
    return word('DeliveryAddress.Type.Options.OnDemand');
  };

  return (
    <Layout
      title={getTitle()}
      backButtonShown={deliveryControl.stackSize > 1}
      onBack={() => onBack()}
      onClose={() => onClose()}
      width={isTablet ? defaultModalSize.tablet.width : defaultModalSize.desktop.width}
      height="auto"
      isDefaultModalSize={false}
      footer={!isMobile && (
        <Button
          id="confirm-pickuptime-pre-order"
          data-cta-name-en="Confirm"
          data-cta-name-th="ยืนยัน"
          data-cta-type="Button"
          className={classes.customButton}
          onClick={onSubmit}
          disabled={!slotId}
        >
          {word('General.Confirm')}
        </Button>
      )}
    >
      <Box ref={contentContainerRef} style={{ maxHeight: !isMobile && '50vh' }}>
        <Box style={{ margin: isMobile ? '0 12px' : isTablet ? '0 20px' : '0', paddingTop: isMobile ? 8 : 0 }}>
          <Box className={classes.root}>
            <CardHeaderUser onNext={() => onNext({ nextPage: DELIVERY_ADDRESS })} />
          </Box>
          {ThSite && (
            <Box className={classes.root}>
              <CardHeaderDetail onBack={() => onNext({ nextPage: SELECT_STORE })} showEdit={!isMatchUrl('payment')} />
            </Box>
          )}
        </Box>
        <Box style={{ margin: isMobile ? '0 12px' : isTablet ? '0 20px' : '0', paddingBottom: isMobile ? 60 : 20 }} mt={ThSite ? 1 : 0}>
          <Box
            className={classes.BoxTime}
            style={{ height: ThSite ? deliveryData.shippingAddress.addressNumber ? 260 : 364 : 260 }}
          >
            <TimeSlot
              collectionSlot={deliverySlot.collectionSlot?.dates || []}
              handleOptionChange={handleOptionChange}
              slotId={slotId}
              containerHeight={ThSite ? deliveryData.shippingAddress.addressNumber ? 260 : 364 : 260}
            />
          </Box>
        </Box>
        {isMobile && (
          <Box mt={2} className={classes.Button}>
            <Button
              id="confirm-pickuptime-pre-order"
              data-cta-name-en="Confirm"
              data-cta-name-th="ยืนยัน"
              data-cta-type="Button"
              style={{
                width: isMobile && '100%',
              }}
              className={classes.customButton}
              onClick={onSubmit}
              disabled={!slotId}
            >
              {word('General.Confirm')}
            </Button>
          </Box>
        )}
      </Box>
    </Layout>
  );
}
